export const isWhatsAppResetEnabled = () => import.meta.env.VITE_WHATSAPP_RESET_ENABLED === 'true';

export const isWhatsAppInvitationEnabled = () => import.meta.env.VITE_WHATSAPP_INVITATIONS_ENABLED === 'true';
